"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toUrl = exports.getCdnByHost = exports.cdnConfigs = exports.addProtocol = exports.API_PREFIX = void 0;
var cdnConfigs = {
  s3: {
    host: 'cdn.oneship.io'
  },
  oss: {
    host: 'cdn.sllogistics.net'
  }
};
exports.cdnConfigs = cdnConfigs;

var getCdnByHost = function getCdnByHost(host) {
  if (host === cdnConfigs.s3.host) {
    return 's3';
  }

  return 'oss';
};

exports.getCdnByHost = getCdnByHost;

var toUrl = function toUrl(_, _ref) {
  var host = _ref.host;
  return host.startsWith('http') || host.startsWith('https') ? host : "https://".concat(host);
};

exports.toUrl = toUrl;

var addProtocol = function addProtocol(host) {
  return host.startsWith('http') || host.startsWith('https') ? host : "https://".concat(host);
};

exports.addProtocol = addProtocol;
var API_PREFIX = 'ones/api/v1/config';
exports.API_PREFIX = API_PREFIX;